module.exports = __webpack_public_path__ + "media/images/wealthbar/transfers/transfer-transfer-2x-33a9dbbfb63ae30d1c9533abc479b292.png";